import { Button, Typography } from '@mui/material';
import {
  ButtonBlockStyled,
  InfoBlockStyled,
  MainBlocksStyled,
  MessageBoxStyled,
  MessageBoxTitleStyled,
} from './styles/MessageBox.styles';
import React from "react";

interface MessageBoxType {
  title: string | JSX.Element;
  subtitle?: string | JSX.Element;
  image: string;
  fullWidth?: boolean;
  welcomePage?: boolean;
  noPolicyLocatedPage?: boolean;
  maxWidth?: string;
}


const MessageBox = ({
  image,
  title,
  subtitle,
  fullWidth = false,
  welcomePage = false,
  maxWidth = 'auto',
  noPolicyLocatedPage,
}: MessageBoxType) => {
  const hasEmail = !!(subtitle || welcomePage);

  return (
    <MessageBoxStyled>
      <MainBlocksStyled
        container
        fullWidth={fullWidth}
        welcomePage={welcomePage}
        maxWidth={maxWidth}
      >
        <InfoBlockStyled item hasEmail={hasEmail} md={12} sm={8}>
          <div>
            <img src={image} alt="Logomark" />
          </div>
          <div>
            <MessageBoxTitleStyled>{title}</MessageBoxTitleStyled>
            <Typography>
              {noPolicyLocatedPage ? (
                <span>
                  Contact us or review our{' '}
                  <a href="https://www.theguarantors.com/faq-for-renters?slug=contact-us"
                     style={{ textDecoration: 'underline' }}>FAQs</a>.
                </span>
              ) : hasEmail ? (
                <span>
                  Email us at{' '}
                  <a href="mailto: ri@theguarantors.com">
                    ri@theguarantors.com
                  </a>
                  .
                </span>
              ) : (
                <span>
                  Give us a call at +1 (212) 266-0020 or navigate to the top of
                  the page to access our{' '}
                  <a href="mailto: ri@theguarantors.com">FAQs</a>.
                </span>
              )}
            </Typography>
          </div>
        </InfoBlockStyled>
        <ButtonBlockStyled item md={12}>
          <Button
            variant="contained"
            onClick={() => {
              if (noPolicyLocatedPage) {
                window.open('https://www.theguarantors.com/contact-us');
              } else if (welcomePage) {
                window.open('https://help.theguarantors.com/renters-insurance');
              } else {
                window.open(`tel:+12122660020`);
              }
            }}
          >
            {noPolicyLocatedPage ? 'Contact us': 'Learn more'}
          </Button>
        </ButtonBlockStyled>
      </MainBlocksStyled>
    </MessageBoxStyled>
  );
};

export { MessageBox };
